import { IActivitySummary } from "us.collection.admin/interfaces";

export function DeleteActivity(this: IActivitySummary) {
  return {
    activityId: this.activityId,
  };
}
